import { render, staticRenderFns } from "./myinfo.vue?vue&type=template&id=8634021e&"
import script from "./myinfo.vue?vue&type=script&lang=js&"
export * from "./myinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports